// Client-only display formatting for $ cost — kept separate from
// token-cost.ts since that file is byte-synced with the Deno copy at
// supabase/functions/_shared/token-cost.ts and this has no server-side use.

/** Formats a $ amount for display. Callers should render `null` as "cost
 * data unavailable" (or similar) rather than passing it here as 0. */
export function fmtCost(cost: number): string {
  if (cost === 0) return "$0.00";
  if (cost < 0.001) return `$${cost.toFixed(5)}`;
  if (cost < 0.01) return `$${cost.toFixed(4)}`;
  if (cost < 1) return `$${cost.toFixed(3)}`;
  return `$${cost.toFixed(2)}`;
}
